import React, { ReactNode } from "react";
import style from "./FilterItem.module.css";

interface PropsFilterItem {
  title: string;
  children?: ReactNode;
  svg: ReactNode;
  routing: string;
  tooltip?: string;
  tooltipAlign?: "left" | "center" | "right";  // ✅ DODANE
}

const FilterItem: React.FC<PropsFilterItem> = ({
  svg,
  title,
  tooltip,
  tooltipAlign = "center",
}) => (
  <div className={style.Icon}>
    <div className={style.Graphic}>
      {svg}

      {tooltip && (
        <div
          className={`${style.Tooltip} ${
            tooltipAlign === "left"
              ? style.TooltipLeft
              : tooltipAlign === "right"
              ? style.TooltipRight
              : style.TooltipCenter
          }`}
        >
          {tooltip}
        </div>
      )}
    </div>

    <div className={style.Title}>{title}</div>
  </div>
);

export default FilterItem;
